import { NgModule } from '@angular/core';
import { SearchTriggerComponent } from '@search/ui';
import { NavigationServiceButtonComponent } from '@core/navigation-ui/navigation-service-button';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import { NavigationSharedModule } from './navigation.shared.module';
import { StickyHeaderContainerComponent } from './sticky-header/sticky-header-container/sticky-header-container.component';
import { StickyHeaderComponent } from './sticky-header/sticky-header.component';
import { TopNavigationComponent } from './sticky-header/top-navigation/top-navigation.component';
import { SearchHeaderComponent } from './shared/search-header/search-header.component';
import { MinimalStickyHeaderComponent } from './minimal-sticky-header/minimal-sticky-header.component';
import { MinimalStickyHeaderContainerComponent } from './minimal-sticky-header/minimal-sticky-header-container/minimal-sticky-header-container.component';

@NgModule({
  imports: [
    NavigationSharedModule,
    SearchTriggerComponent,
    SearchHeaderComponent,
    NavigationServiceButtonComponent,
    DeployUrlPipe,
    CSCaptureDirective,
    StickyHeaderComponent,
    StickyHeaderContainerComponent,
    TopNavigationComponent,
    MinimalStickyHeaderComponent,
    MinimalStickyHeaderContainerComponent,
  ],
  exports: [
    StickyHeaderContainerComponent,
    MinimalStickyHeaderContainerComponent,
    TopNavigationComponent,
  ],
})
export class NavigationEssentModule {}
